import axios from 'axios';
import { useToast } from '@/composables/use-toast';

const { addToast } = useToast();

// Set the base URL with /api prefix
axios.defaults.baseURL = 'https://datalab.portexai.com';

// Set upload limits to 4MB
axios.defaults.maxContentLength = 4 * 1024 * 1024; // 4MB
axios.defaults.maxBodyLength = 4 * 1024 * 1024; // 4MB

// Add request interceptor for debugging
axios.interceptors.request.use(request => {
  
  // Add CORS headers
  if (request.responseType !== 'blob') {
    request.headers['Accept'] = 'application/json';
    request.headers['Content-Type'] = 'application/json';
  }

  if (request.headers['Content-Type'] === 'multipart/form-data') {
    request.headers['Content-Type'] = 'multipart/form-data';
  }
  
  // Log request in development
  if (process.env.NODE_ENV === 'development') {
    console.log('API Request:', {
      method: request.method,
      url: request.url,
      baseURL: request.baseURL,
      headers: request.headers
    });
  }
  
  return request;
});

// Add response interceptor for debugging
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Handle CORS errors specifically
    if (error.code === 'ERR_NETWORK' || error.message.includes('CORS')) {
      console.error('CORS Error:', {
        message: 'Cross-origin request blocked. Check your proxy configuration or backend CORS settings.',
        url: error.config?.url,
        method: error.config?.method,
        baseURL: error.config?.baseURL
      });
      
      // Don't show toast for CORS errors in development
      if (process.env.NODE_ENV !== 'development') {
        addToast('Network error: Cross-origin request blocked', 'error');
      }
    } else {
      addToast(error.response?.data?.message ?? error.message, 'error');
      console.error('API Error:', {
        message: error.message ?? error.response?.data?.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url,
        method: error.config?.method
      });
    }

    // Check for 503 status and redirect
    if (error.response?.status === 503) {
     window.location.href = '/status/503';
    }

    return Promise.reject(error instanceof Error ? error : new Error(error.message || 'Network Error'));
  }
);

export default axios;